"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const components_overlay_Modal_components_hooks_useModalContext = require("./hooks/useModalContext.js");
const ModalProvider = ({ value, children }) => {
  return /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Modal_components_hooks_useModalContext.ModalContext.Provider, { value, children });
};
exports.ModalProvider = ModalProvider;
